module.exports = __webpack_public_path__ + "img/homepage-placeholder.eb05e75.jpg";